import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function DatabaseMySQL() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const mysqlServices = [
        "Installazione e configurazione MySQL/MariaDB",
        "Performance tuning e ottimizzazione query",
        "Backup automatici e disaster recovery",
        "Master-Slave replication setup",
        "MySQL Cluster (NDB) implementation",
        "Security hardening e user management",
        "Database monitoring e alerting",
        "Migration da altri DBMS"
    ];

    const performanceFeatures = [
        "Query optimization e indexing",
        "InnoDB configuration tuning",
        "Buffer pool optimization",
        "Slow query log analysis",
        "Connection pooling setup",
        "Table partitioning strategies",
        "Memory usage optimization",
        "Disk I/O performance tuning"
    ];

    const highAvailability = [
        "Master-Master replication",
        "MySQL Group Replication",
        "Galera Cluster setup",
        "ProxySQL load balancing",
        "Automatic failover configuration",
        "Point-in-time recovery",
        "Binary log management",
        "Cross-datacenter replication"
    ];

    const securityFeatures = [
        "SSL/TLS encryption setup",
        "User privilege management",
        "Database audit logging",
        "Data masking e anonymization",
        "Backup encryption",
        "Access control implementation",
        "Security vulnerability assessment",
        "Compliance reporting (GDPR, PCI)"
    ];

    const monitoringTools = [
        "MySQL Enterprise Monitor",
        "Percona Monitoring Management",
        "Prometheus + Grafana dashboards",
        "Custom metrics collection",
        "Real-time performance monitoring",
        "Capacity planning reports",
        "Alerting su thresholds critici",
        "Historical trend analysis"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Database MySQL/MariaDB</h1>
                    <p className="service-description">
                        Amministrazione professionale MySQL e MariaDB con ottimizzazione performance,
                        alta disponibilità e backup automatici per i tuoi dati critici.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={8}>
                            <div className="service-description">
                                <h3>Amministrazione MySQL Professionale</h3>
                                <p>
                                    Gestisco database MySQL e MariaDB con competenza certificata,
                                    garantendo performance ottimali, sicurezza avanzata e alta disponibilità
                                    per applicazioni web, e-commerce e sistemi enterprise.
                                </p>
                                <p>
                                    Dalla configurazione iniziale all'ottimizzazione di query complesse,
                                    offro soluzioni complete per massimizzare l'efficienza del tuo
                                    database e proteggere i dati critici del business.
                                </p>
                            </div>

                            <div className="mysql-services">
                                <h3>Servizi MySQL/MariaDB</h3>
                                <Row>
                                    {mysqlServices.map((service, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🗄️</span>
                                                {service}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="performance-section">
                                <h3>Performance Optimization</h3>
                                <Row>
                                    {performanceFeatures.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">⚡</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="info" className="mysql-alert">
                                <h5><i className="fas fa-database"></i> Performance Tuning</h5>
                                <p>
                                    Ottimizzazione avanzata delle configurazioni MySQL per massimizzare
                                    throughput, ridurre latenza e gestire efficacemente carichi elevati
                                    con tuning personalizzato per il tuo workload.
                                </p>
                            </Alert>

                            <div className="ha-section">
                                <h3>Alta Disponibilità e Replication</h3>
                                <Row>
                                    {highAvailability.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🔄</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="security-section">
                                <h3>Sicurezza e Compliance</h3>
                                <Row>
                                    {securityFeatures.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🔒</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="monitoring-section">
                                <h3>Monitoring e Analytics</h3>
                                <Row>
                                    {monitoringTools.map((tool, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">📊</span>
                                                {tool}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Processo di Gestione Database</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Assessment database esistente e requirements</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Configurazione ottimale e security hardening</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Setup monitoring, backup e replication</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Manutenzione proattiva e ottimizzazione continua</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Piani MySQL</h4>
                                        <div className="pricing-plan">
                                            <h5>MySQL Basic</h5>
                                            {/* <div className="plan-price">€150/mese</div> */}
                                            <ul>
                                                <li>1 Database instance</li>
                                                <li>Basic monitoring</li>
                                                <li>Backup giornalieri</li>
                                                <li>Performance tuning base</li>
                                                <li>Supporto 9-18</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan featured">
                                            <h5>MySQL Professional</h5>
                                            {/* <div className="plan-price">€300/mese</div> */}
                                            <ul>
                                                <li>Fino a 3 instances</li>
                                                <li>Master-Slave replication</li>
                                                <li>Advanced monitoring</li>
                                                <li>Query optimization</li>
                                                <li>Monitoring 24/7</li>
                                                <li>Support prioritario</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan">
                                            <h5>MySQL Enterprise</h5>
                                            {/* <div className="plan-price">€500/mese</div> */}
                                            <ul>
                                                <li>Cluster multi-master</li>
                                                <li>High availability setup</li>
                                                <li>Advanced security</li>
                                                <li>Disaster recovery</li>
                                                <li>DBA dedicato</li>
                                                <li>SLA 99.9%</li>
                                            </ul>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card className="mysql-versions-card">
                                    <Card.Body>
                                        <h4>📋 Versioni Supportate</h4>
                                        <ul>
                                            <li>MySQL 8.0 (Latest)</li>
                                            <li>MySQL 5.7 (LTS)</li>
                                            <li>MariaDB 10.6+</li>
                                            <li>Percona Server</li>
                                            <li>Amazon RDS MySQL</li>
                                            <li>Google Cloud SQL</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="tools-card">
                                    <Card.Body className="text-center">
                                        <h5>🛠️ Tools Utilizzati</h5>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>MySQL Workbench</li>
                                            <li>Percona Toolkit</li>
                                            <li>pt-online-schema-change</li>
                                            <li>MySQLTuner</li>
                                            <li>Innotop monitoring</li>
                                            <li>ProxySQL</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo MySQL</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
            </Container>
        </div>
    );
}

export default DatabaseMySQL;